"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lessons = require("../../../utils/lessons.util");
var _Icon = require("../../../components/Icon/Icon");
var _reactRouterDom = require("react-router-dom");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var LessonsNavLink = function LessonsNavLink(_ref) {
  var route = _ref.route,
    lesson = _ref.lesson,
    _ref$linkPrefix = _ref.linkPrefix,
    linkPrefix = _ref$linkPrefix === void 0 ? 'Next' : _ref$linkPrefix;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "text-green1-55 hover:text-green1-55",
    to: route
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('w-full flex flex-row justify-between items-center bg-white px-[22px] h-[106px]', 'text-left tw-label-medium border-0 border-t-[1px] border-b-[1px] border-solid border-grey-20')
  }, linkPrefix, ": ", (0, _lessons.getLessonTitleWithOrdinal)(lesson.title, lesson.ordinal), /*#__PURE__*/_react.default.createElement("div", {
    className: "pl-[15px]"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "caret-right-heavy-16",
    size: 16
  }))));
};
var _default = LessonsNavLink;
exports.default = _default;